<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import UserManagmentComponent from './UserManagmentComponent.vue';

    export default {
    name: 'UserManagmentPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, UserManagmentComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <UserManagmentComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>